/** @jsx jsx */
import { jsx } from '@emotion/core';
import { ReactElement, useState } from 'react';

export enum TagType {
  div = 'div',
  span = 'span',
}

type Props = {
  children: (options: { isHovered: boolean }) => ReactElement;
  /** Default is 0 */
  tabIndex?: number;
  /** Default is div */
  tag?: TagType;
};

/**
 * Injects `isHovered` into child function component when user hovers
 */
const Hoverable = ({ children, tag, tabIndex = 0 }: Props) => {
  const [isHovered, setIsHovered] = useState(false);
  const Tag = tag || TagType.div;

  const onHover = (value: boolean) => {
    setIsHovered(value);
  };

  return (
    <Tag
      onBlur={() => onHover(false)}
      onFocus={() => onHover(true)}
      onMouseEnter={() => onHover(true)}
      onMouseLeave={() => onHover(false)}
      tabIndex={tabIndex}
    >
      {children({ isHovered })}
    </Tag>
  );
};

export default Hoverable;
